// @flow

// For collage Pins, CollageChips is the row of square Pin images below the main
// full-size image. It's built to support any number of chips and any width Pin.

import React from 'react';
import CloseupLink from 'app/common/react/components/PinRep/components/CloseupLink';
import { type BasicImage } from 'app/packages/pinterest-flow-types/image';
import { type Pin } from 'app/common/react/components/PinRep/types';
import { Box, Image, Mask } from 'gestalt';

const styles = {
  chip: {
    marginRight: 1,
    flex: '1 1 0',
  },
  chipInner: {
    paddingBottom: '100%',
  },
  chipContainer: {
    marginRight: -1,
  },
};

type Chip = {|
  id: string,
  images: {
    '750x': BasicImage,
  },
|};

export type Props = {|
  pin: Pin,
  enableCloseupLink: boolean,
|};

export default function CollageChips({ pin, enableCloseupLink }: Props) {
  const { aggregated_pin_data } = pin;
  const { pin_tags_chips: collageChips } = aggregated_pin_data || {};
  // we may have more or less than 3 chips returned by the API if the pin is promoted,
  // since we need to prefetch some data for closeup
  const truncatedChips = collageChips && collageChips.length >= 3 ? collageChips.slice(0, 3) : [];

  return (
    <Box
      display="flex"
      dangerouslySetInlineStyle={{
        __style: styles.chipContainer,
      }}
    >
      {truncatedChips.map((chip: Chip) => {
        const image = chip.images['750x'] || {};
        const imageDisplay = (
          <Image
            alt=""
            fit="cover"
            naturalHeight={image.height}
            naturalWidth={image.width}
            src={image.url}
          />
        );

        return (
          <Box
            dangerouslySetInlineStyle={{
              __style: styles.chip,
            }}
            data-test-id="collageChip"
            key={chip.id}
          >
            <Box
              dangerouslySetInlineStyle={{
                __style: styles.chipInner,
              }}
              position="relative"
            >
              <Box position="absolute" top left right bottom>
                <Mask height="100%" wash width="100%">
                  {enableCloseupLink ? (
                    <CloseupLink
                      additionalStyles={{ width: '100%', height: '100%' }}
                      collageChipId={chip.id}
                      pin={pin}
                    >
                      {imageDisplay}
                    </CloseupLink>
                  ) : (
                    imageDisplay
                  )}
                </Mask>
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
